import { pickBy, identity } from 'lodash/fp';
import { Person } from '../../../../global/entities/Person';
import { BuyOrderRelation } from '../../../../utils/types/buy-order-relations';
import { RelationType } from '../../../../global/entities/BuyOrder';

export const pickPersonRelation = (
  person: BuyOrderRelation<Person>,
  relationType?: RelationType,
): {
  numberShares: number;
  relationType: RelationType;
  person: string;
  relationId?: string;
} =>
  // We know that numberShares, relationType and person will always be present
  // as a user cannot submit a form without specifying numberShares, relationType and social security number.
  // `person` == `socialSecurityNumber`
  // @ts-expect-error
  pickBy(identity, {
    numberShares: Number(person.numberShares),
    relationType: relationType || person.relationType,
    person: person.socialSecurityNumber,
    relationId: person.relationId,
  });
